import React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import gtm from '@periodica/analytics/gtm';

import { Accordion } from '@components/Blocks/Accordion';

import { BaseContainer, Heading } from '@periodica/ui-kit';
import { Breadcrumbs } from '@components/Blocks/Breadcrumbs';
import { SiteContentLayout } from '@components/Layouts/SiteContentLayout';
import { GiftForm } from './components/GiftForm';
import { GiftBanner } from './components/GiftBanner';

import styles from './GiftPage.module.scss';
import { breadcrumbsPath } from './consts';

function GiftPage() {
  const location = useLocation();

  const handleAccordionClick = () => {
    gtm.logEvent({ name: 'event_site_gift_accordeon-click' });
  };

  const faqItems = [
    {
      groupTitle: '',
      groupRank: 0,
      groupItems: [
        {
          title: 'На что действует сертификат?',
          answer:
            'Сертификатом можно частично или полностью оплатить заказ. Его можно потратить на любую печатную продукцию Периодики, а также на услугу <a href="/design-photobook" target="_blank">«Соберем фотокнигу за вас»</a>',
          rank: 0,
        },
        {
          title: 'Как активировать сертификат?',
          answer:
            'Код сертификата вводится в поле для промокода на финальном этапе оформления заказа — в корзине.',
          rank: 1,
        },
        {
          title: 'Сколько действует сертификат?',
          answer:
            'Срок действия наших сертификатов — 12 месяцев с момента отправки сертификата получателю. Сертификат можно использовать несколько раз до исчерпания баланса и он суммируется с другими сертификатами и промокодами.',
          rank: 2,
        },
      ],
    },
  ];
  return (
    <BaseContainer>
      <Breadcrumbs path={breadcrumbsPath} />
      <SiteContentLayout>
        <GiftBanner />
        <GiftForm values={location?.state as any} />
        <div className={styles.FAQBlock}>
          <Heading variant="h3" color="primary" className={styles.h3}>
            Вопросы и ответы
          </Heading>
          <div className={styles.accordionContainer} onClick={handleAccordionClick}>
            <Accordion title="" items={faqItems} />
          </div>
        </div>
      </SiteContentLayout>
    </BaseContainer>
  );
}

export default GiftPage;
